import styled from "styled-components";

export const Container = styled.div`
  h3 {
    font-size: 16px;
    line-height: 24px;
    color: #4a4a4a;
    font-weight: 400;
    span {
      font-weight: 900;
    }
  }
`;
export const Content = styled.div`
  display: flex;
  margin-top: 16px;
`;
export const ContentLeft = styled.div`
  width: 257px;
  flex-shrink: 0;
  margin-right: 86px;
  p {
    font-size: 16px;
    line-height: 24px;
    color: #4a4a4a;
  }
  ${(props) =>
    props.theme.rtl &&
    `
        margin-right: unset;
        margin-left: 86px;
    `}
`;
export const ContentRight = styled.div`
  flex: 1;
  h4 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 900;
    color: #333333;
    margin-bottom: 12px;
  }
  p {
    font-size: 16px;
    line-height: 24px;
    color: #4a4a4a;
    span {
      font-weight: 900;
    }
  }
`;
